import { useMutation } from "@tanstack/react-query";
import {
  testRemoteConnection,
  migrateCompanyData,
} from "services/companyMigration";

export const useTestRemoteConnection = () => {
  return useMutation({
    mutationFn: (data) => testRemoteConnection(data),
  });
};

export const useMigrateCompanyData = () => {
  return useMutation({
    mutationFn: (data) => migrateCompanyData(data),
  });
};
